import React from 'react';

import Thumbnail from './Thumbnail';
import Name from './Name';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { useContext } from 'react';
import { UserDetailsContext } from 'context/userDetailsContext';
import { useFileNavigation } from 'modules/FileManagerV2/hooks/ui/useFileNavigation';

const GridItem = React.memo(function GridItem({ item }) {
  const { handleBreadCrumbs, onFilterChange, fileManagerFilters } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);
  const { selectFile } = useFileNavigation({ handleBreadCrumbs, onFilterChange, fileManagerFilters, userContext });

  return (
    <div
      style={{ ...(item.entry_type === 'image' ? { height: '100%' } : {}) }}
      className="pointer card-bg fileManager-item"
      onClick={() => selectFile(item)}
    >
      <Thumbnail item={item} selectFile={selectFile} />
      <Name item={item} selectFile={selectFile} />
    </div>
  );
});

export default GridItem;
